import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ReturnRouteService } from '../../../../../../core/services/navigation/return-route.service';
import { RouteConstants } from '../../../../../../core/constants/routes';
import { DirectEntryStepPaths } from '../../../../../../modules/application/direct-entry/shared/constants/direct-entry-steps';
import { isUnsupportedPurpose } from '../../../../../../modules/application/shared/constants/application-purpose-codes';
import { ApplicationIdCellRendererParams } from './models/application-id-cell-renderer-params';

@Component({
    selector: 'app-application-id-cell-renderer',
    templateUrl: './application-id-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class ApplicationIdCellRendererComponent
    implements ICellRendererAngularComp
{
    params!: ApplicationIdCellRendererParams;

    constructor(
        private readonly router: Router,
        private readonly returnRouteService: ReturnRouteService,
    ) {}

    agInit(params: ApplicationIdCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

    navigate(): void {
        this.returnRouteService.set(this.params.returnRoute ?? null);
        this.router.navigate([this.getRouterLink()]);
    }

    getRouterLink(): string {
        const id = String(this.params.data.applicationId);
        const purpose = this.params.data.applicationPurpose;

        if (this.params.data.isForm160) {
            return RouteConstants.FrnFiling.getFullRouteWithApplicationId(
                'typeOfFiling',
                id,
            );
        }

        return isUnsupportedPurpose(purpose)
            ? RouteConstants.Application.getFullRouteWithApplicationId(
                  'unsupported',
                  id,
              )
            : RouteConstants.Application.getDirectEntryFullRouteWithApplicationId(
                  DirectEntryStepPaths.generalInfo,
                  id,
              );
    }

    getDisplayAppId(): string {
        return this.params.data.isForm160
            ? String(this.params.data.applicationId)
            : this.params.data.salmonLogId!;
    }
}
